import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  Divider,
  TextField,
  Avatar
} from "@material-ui/core";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import {clientNotifier} from "configurations/axios";
import Alert from "widgets/alert";
import {
  API_GET_ALL_TEMPLATE,
} from "./apis";
import { useStylesApp } from "hooks/useStyles";
import SaveIcon from "@material-ui/icons/Save";
import pdfIcon from "assets/icons/pdf.png";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  btnReport: {
    borderRadius: "8px",
    borderStyle: "dashed",
    borderWidth: "1px",
    borderColor: palette.primary.main,
    color: palette.primary.main,
    marginTop: "1%",
    marginRight: "1%",
  },
}));

const AddTemplateBtn = ({ updateTemplate, setUpdateTemplate, sendTemplate, setSendTemplate, iDoc, txt }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [template, setTemplate] = useState([]);
  const [loadTemplate, setLoadTemplate] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const userToken = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });

  useEffect(()=>{
    if(sendTemplate === 1 || sendTemplate === 2){
      handleClose();
    }
  },[sendTemplate])

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClickOpen = () => {
    setOpen(true);
    setLoadTemplate(true);
    setMsg({ show: false, msg: null, type: null });
    setSelectedTemplate({});
    setUpdateTemplate('')
  };

  const handleClose = () => {
    setOpen(false);
    setTemplate([]);
    setSelectedTemplate({})
    setUpdateTemplate('')
  };

  const getTemplates = async (token) => {
    setLoadTemplate(false);
    if (open) {
      await clientNotifier
        .get(API_GET_ALL_TEMPLATE+getRUCEmpresa(userToken)+"/"+iDoc)
        .then((result) => {
          if (result.status === 200) {
            let locations = result.data;
            for (let i = 0; i < locations.length; i++) {
              locations[i].label =
                locations[i].plantillaCafe.codigo + " / " + locations[i].plantillaCafe.nombre;
            }
            setTemplate(locations);
          }
        })
        .catch((exception) => {
          setTemplate([
            { label: "Error al cargar los templates" },
          ]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar los templates.",
          });
        });
    }
  };

  const renderTemplates = () => {
    if (template.length === 0 && userToken && loadTemplate) {
      getTemplates(userToken);
    }
    return (
      <>
        <Autocomplete
          value={selectedTemplate}
          onChange={(event, newValue) => {
            setSelectedTemplate(newValue);
          }}
          options={template}
          getOptionLabel={(option) => option.label}
          style={{ width: "95%" }}
          loading={template.length === 0}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Lista de templates"
              classes={{ root: classes.textFieldComboBox }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {template.length === 0 ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </>
    );
  };

  const handleGenerateTemplate = () =>{
    if(selectedTemplate){
      if(selectedTemplate.plantillaCafe)
      setUpdateTemplate(selectedTemplate.plantillaCafe.codigo);
    }
    setSendTemplate(sendTemplate)
    //setSendTemplate(true);
  }

  return (
    <Fragment>
      <Button variant="text" onClick={handleClickOpen} className={classes.btnReport} fullWidth>
        {sendTemplate === 1 ?
        <Avatar variant="square" src={pdfIcon} className={classes.small} />
        :
        <SaveIcon style={{ color: palette.info.main }} fontSize="large" />
      }
        {txt}
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">Seleccionar template</DialogTitle>
        <DialogContent>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item md={12} xs={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              
              <Grid item md={1} xs={12} className={classes.divForm}>
                <label>Template:</label>
              </Grid>
              <Grid item md={5} xs={12} className={classes.divInput}>
                {renderTemplates()}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={handleGenerateTemplate}
                  className={classesGlobal.marginButton}
                >
                  {txt}
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AddTemplateBtn;
